import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const UtentiConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/utenti/:id?',
      component: FuseLoadable({
        loader: () => import('./Utenti')
      })
    }
  ]
}
